import React, { Component } from 'react';
import { bool, func, node, number, string } from 'prop-types';
import ReactTooltip from 'rc-tooltip';
import classnames from 'classnames';
import shallowCompare from 'react-addons-shallow-compare';

class Tooltip extends Component {
    shouldComponentUpdate(newProps, newState) {
        return shallowCompare(this, newProps, newState);
    }

    render() {
        const tooltipProps = {
            mouseEnterDelay: 0,
            mouseLeaveDelay: this.props.delay,
            overlay: this.props.overlayContent,
            overlayClassName: classnames('animated-once-fast', 'fade-in', this.props.overlayClassName),
            overlayStyle: { width: 'max-content' },
            placement: this.props.placement,
            prefixCls: 'tooltip',
        };

        if (this.props.appendToBody) {
            tooltipProps.getTooltipContainer = () => document.body;
            tooltipProps.overlayStyle = {
                ...tooltipProps.overlayStyle,
                zIndex: 9999,
                position: 'fixed',
            };
        }

        return (
            <ReactTooltip {...tooltipProps}>
                {this.props.children}
            </ReactTooltip>
        );
    }
}

Tooltip.propTypes = {
    appendToBody: bool,
    children: node.isRequired,
    delay: number,
    overlayClassName: string,
    overlayContent: node.isRequired,
    placement: string,
};

Tooltip.defaultProps = {
    appendToBody: false,
    delay: 0,
    overlayClassName: null,
    placement: 'top',
};

export default Tooltip;
